import * as React from "react";
import { useLocation } from "react-router-dom";
import { Main } from "../components";
import MainProjects from "../components/main-projects";
import TechnicalWritingSection from "../components/main-blogs";
import ContactLandingPage from "../components/main-contact";
import {Helmet} from "react-helmet-async";

export default function HomeRoute(): JSX.Element {
    const location = useLocation();

    React.useEffect(() => {
        if (location.hash !== "#contact") return;

        // ensure DOM is painted (StrictMode runs effects twice in dev; this is fine)
        requestAnimationFrame(() => {
            document
                .getElementById("contact-section")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }, [location.hash]);

    return (
        <>
            <Helmet>
                <title>Aggrey Lelei | Head of Tech, Software Architect</title>
                <meta
                    name="description"
                    content="Portfolio, projects, technical writing, and backend engineering work by Aggrey Lelei."
                />

                <link rel="canonical" href="https://aggreylelei.com/" />

                <meta property="og:title" content="Aggrey Lelei | Head of Tech, Software Architect" />
                <meta
                    property="og:description"
                    content="Portfolio, projects, technical writing, and backend engineering work by Aggrey Lelei."
                />
                <meta property="og:site_name" content="Aggrey Lelei" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aggreylelei.com/" />
                <meta property="og:image" content="https://aggreylelei.com/og-image.jpg" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Aggrey Lelei | Head of Tech, Software Architect" />
                <meta
                    name="twitter:description"
                    content="Portfolio, projects, technical writing, and backend engineering work by Aggrey Lelei."
                />
                <meta name="twitter:image" content="https://aggreylelei.com/og-image.jpg" />
            </Helmet>
            <Main />
            <MainProjects />
            <TechnicalWritingSection />
            <ContactLandingPage />
        </>
    );
}
